import * as React from 'react';
import { Col, Row, Label } from 'reactstrap';
import { momentToString, timestampToMoment } from 'src/share/utils/utils';
import usePhotoViewer from 'src/share/components/PhotoViewer/usePhotoViewer';

const AbductorInfoMatch = ({ matchInfo }) => {
  const hasImageSource = matchInfo && matchInfo.details && matchInfo.details.photoFace && matchInfo.details.photoFace.url;
  const { handleZoomInImage } = usePhotoViewer();
  return (
    <Col md={5}>
      <div className="match-info biometrica-info white-background">
        <Row>
          <Col md={12} className="imageContainer">
            <div className="col-xs-12">
              <div className="col-xs-12 img-container" >
                <div className="container-img" onClick={() => handleZoomInImage({ source: hasImageSource, boundingBoxes: [] })}>
                  <img src={hasImageSource} />
                  <div className="bounding-box" style={{ position: 'absolute' }} />
                </div>
              </div>
            </div>
          </Col>
          <Col md={12} className="stats-info">
            { matchInfo.provider === 'Biometrica-Automatic' && 
            <>
              <h5 className='label'>{matchInfo.personType === 'abductors' ? "Companion's information:" : "Child's information:"}</h5>
              <p><Label>Name:</Label>{matchInfo.personInfo.name || 'Unknown'}</p>
              <p><Label>Sex:</Label>{matchInfo.personInfo.sex || 'Unknown'}</p>
              <p><Label>Weight:</Label>{matchInfo.personInfo.weight || 'Unknown'}</p>
              <p><Label>Height:</Label>{matchInfo.personInfo.height || 'Unknown'}</p>
            </>
            }
            <p><Label>Match date:</Label>{matchInfo.date ? momentToString(timestampToMoment(matchInfo.date)) : 'Unknown'}</p>
            <p><Label>Provider:</Label>{matchInfo.provider || 'Unknown'}</p>
            <p><Label>Faces detected results:</Label>{matchInfo.details && matchInfo.details.suspects && matchInfo.details.suspects.length || 'Unknown'}</p>
          </Col>
        </Row>
      </div>
    </Col>
  )
};

export default React.memo(AbductorInfoMatch)